<div class="flex flex-col h-full">
  <!-- Header -->
  <div class="flex items-center justify-between mb-6">
    <div class="flex items-center gap-2">
      <div
        class="w-9 h-9 bg-info"
        style="
          mask: url('/icons/hi-outline-cog8tooth.svg') no-repeat center / contain;
          -webkit-mask: url('/icons/hi-outline-cog8tooth.svg') no-repeat center / contain;
        "
      ></div>
      <h1 class="text-2xl font-bold text-primary">Validation Rules</h1>
    </div>
  </div>

  <!-- Tab navigation -->
  <div class="border-b border-base-300 mb-4">
    <nav class="-mb-px flex gap-6" aria-label="Validation rules tabs">
      <button
        type="button"
        (click)="setTab('rules')"
        [class.border-info]="activeTab() === 'rules'"
        [class.text-info]="activeTab() === 'rules'"
        [class.border-transparent]="activeTab() !== 'rules'"
        [ngClass]="activeTab() !== 'rules' ? 'text-base-content/70' : ''"
        class="py-2 px-1 border-b-2 font-medium text-sm hover:text-info hover:border-info transition-colors"
      >
        Rules by Template
      </button>
      <button
        type="button"
        (click)="setTab('location')"
        [class.border-info]="activeTab() === 'location'"
        [class.text-info]="activeTab() === 'location'"
        [class.border-transparent]="activeTab() !== 'location'"
        [ngClass]="activeTab() !== 'location' ? 'text-base-content/70' : ''"
        class="py-2 px-1 border-b-2 font-medium text-sm hover:text-info hover:border-info transition-colors"
      >
        Location Hierarchy
      </button>
      <button
        type="button"
        (click)="setTab('rule-types')"
        [class.border-info]="activeTab() === 'rule-types'"
        [class.text-info]="activeTab() === 'rule-types'"
        [class.border-transparent]="activeTab() !== 'rule-types'"
        [ngClass]="activeTab() !== 'rule-types' ? 'text-base-content/70' : ''"
        class="py-2 px-1 border-b-2 font-medium text-sm hover:text-info hover:border-info transition-colors"
      >
        Rule Types
      </button>
    </nav>
  </div>

  <!-- Tab content -->
  <div class="flex-1 overflow-hidden">
    <app-rules-by-template-tab *ngIf="activeTab() === 'rules'"></app-rules-by-template-tab>
    <app-location-hierarchy-tab *ngIf="activeTab() === 'location'"></app-location-hierarchy-tab>
    <app-rule-types-tab *ngIf="activeTab() === 'rule-types'"></app-rule-types-tab>
  </div>
</div>
